import type { UseHttp } from '~~/server/api/interface'

export const fetchSendVerifyCode: UseHttp = (params, option) => {
  return useHttp.get(
    `/api/auth/sendRegisterVerifyCode/${params?.phone}/${params?.code}`,
    undefined,
    { ...option }
  )
}

export const fetchForget: UseHttp = (params, option) => {
  return useHttp.post('/api/auth/forget', params, { ...option })
}

export const fetchAuthLogin: UseHttp = (params, option) => {
  return useHttp.post('/api/auth/login', params, { ...option })
}

export const fetchAuthWxLogin: UseHttp = (params, option) => {
  return useHttp.get(`/api/auth/wxlogin/${params?.ticket}`, undefined, { ...option })
}

export const fetchGetWxQRScanCode: UseHttp = (params, option) => {
  return useHttp.get('/api/auth/getWxQRScanCode', undefined, { ...option })
}

export const fetchAuthLogout: UseHttp = (params, option) => {
  return useHttp.get('/api/auth/logout', undefined, { ...option })
}

export const fetchAuthLoginByCode: UseHttp = (params, option) => {
  return useHttp.get(`/api/auth/phonelr/${params?.phone}/${params?.code}`, undefined, { ...option })
}

export const fetchAuthBind: UseHttp = (params, option) => {
  return useHttp.post('/api/auth/bind', params, { ...option })
}

export const fetchGenerateCaptcha: UseHttp = (params, option) => {
  return useHttp.get('/api/captchaApi/generate', undefined, { ...option })
}

export const fetchVerifyCaptcha: UseHttp = (params, option) => {
  return useHttp.post(`/api/captchaApi/verify/${params?.code}`, undefined, { ...option })
}


// export const fetchOSSNewsContent: UseHttp = (params, option) => {
//   return useHttp.get(env[MODE].HOST_NAME +`/ossApi/newsContent/${params?.newsId}.html`, undefined, { ...option })
// }

// export const fetchOSSInnerChainInfo: UseHttp = (params, option) => {
//   return useHttp.get(env[MODE].HOST_NAME + '/ossApi/InnerChainInfo/key.json', undefined, { ...option })
// }
export const fetchOSSNewsContent: UseHttp = (params, option) => {
  return useHttp.get(`/ossApi/newsContent/${params?.newsId}.html`, undefined, { ...option })
}

export const fetchOSSInnerChainInfo: UseHttp = (params, option) => {
  return useHttp.get('/ossApi/InnerChainInfo/key.json', undefined, { ...option })
}

// auth
export const fetchEditUserInfo: UseHttp = (params, option) => {
  return useHttp.post('/api/user/editInfo', params, { ...option })
}

export const fetchMyIndustry: UseHttp = (params, option) => {
  return useHttp.get('/api/user/myIndustry', undefined, { ...option })
}

export const fetchEditMyIndustry: UseHttp = (params, option) => {
  return useHttp.post('/api/user/myIndustry/edit', params, { ...option })
}

export const fetchUserInfo: UseHttp = (params, option) => {
  return useHttp.get('/api/user/getInfo', undefined, { ...option })
}

export const fetchCheckUserExist: UseHttp = (params, option) => {
  return useHttp.get(`/api/user/checkExist/${params?.value}`, undefined, { ...option })
}


import type { SearchParameters } from 'ofetch'
import type { AvailableRouterMethod, NitroFetchOptions, NitroFetchRequest } from 'nitropack'

// 获取我的关注列表
export const fetchMyFollowList = <R extends NitroFetchRequest, M extends AvailableRouterMethod<R>>(
  params?: SearchParameters,
  option?: NitroFetchOptions<R, M>
) => {
  return useHttp.post('/api/userFollowApi/myFollowList', params, { ...option })
}

// 获取我的粉丝列表
export const fetchMyBeFollowedList = <R extends NitroFetchRequest, M extends AvailableRouterMethod<R>>(
  params?: SearchParameters,
  option?: NitroFetchOptions<R, M>
) => {
  return useHttp.post('/api/userFollowApi/myBeFollowedList', params, { ...option })
} 


import type { ResOptions } from '~/composables/httpHelper'

export const fetchVisitorListByCurrent: UseHttp = (params, option) => {
  const token = useCookie('access_token')
  if (!token.value) return Promise.resolve({} as ResOptions<any>)
  return useHttp.post('/api/visitor/list-by-current', undefined, { ...option })
}

export const clientFetchVisitorListByCurrent: UseHttp = (params, option) => {
  return useHttp.post('/api/visitor/list-by-current', undefined, { ...option })
}

export const clientFetchDeleteVisitor: UseHttp = (params, option) => {
  return useHttp.post('/api/visitor/delete', params, { ...option })
}

export const clientFetchCreateVisitor: UseHttp = (params, option) => {
  return useHttp.post('/api/visitor/create', params, { ...option })
}

export const clientFetchUpdateVisitor: UseHttp = (params, option) => {
  return useHttp.post('/api/visitor/update', params, { ...option })
}
